import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles } from './maker-about-vc.module.style';
export function MakerAboutVc(props) {
  return _jsx("div", {
    css: containerStyles,
    children: _jsxs("div", {
      className: "page-container pure-g",
      children: [_jsx("div", {
        className: props.context.isMobileView ? "pure-u-1" : "pure-u-6-24",
        children: _jsxs("picture", {
          children: [_jsx("source", {
            srcSet: "/_mp-images/about_us.webp",
            type: "image/webp"
          }), _jsx("img", {
            src: "_mp-images/about_us.png"
          })]
        })
      }), _jsx("div", {
        className: "".concat(props.context.isMobileView ? "pure-u-1 pt-8" : "pure-u-18-24 pl-32 pr-32", " flex items-center"),
        children: _jsxs("div", {
          children: [_jsx(Typography, {
            type: props.context.isMobileView ? "Headline_H1" : "Heading2",
            color: "heavy_metal",
            className: "text-center",
            bold: true,
            children: "About Us"
          }), _jsx(Typography, {
            type: "Headline_H3",
            color: "nero",
            className: props.context.isMobileView ? "pt-6" : "pt-8",
            children: "Vibecity believes in bringing together passionate creators and people looking for products with stories."
          }), _jsx(Typography, {
            type: "Headline_H3",
            color: "nero",
            className: props.context.isMobileView ? "pt-6" : "pt-8",
            children: "Vibecity is about taking shopping back to its roots, keeping alive the spirit of craftsmanship. It is powering online commerce for community of artisans, craftsman & creators. It's online, but entirely human."
          })]
        })
      })]
    })
  });
}
export default MakerAboutVc;